import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/auth/c/doLogin",
    method: "post",
    data,
  });
}

export function getPicCaptcha() {
  return request({
    url: "/auth/c/getPicCaptcha",
    method: "get",
  });
}

export function logout() {
  return request({
    url: "/auth/c/doLogout",
    method: "get",
  });
}

export function updatePassword(data) {
  return request({
    url: "/auth/c/updatePassword",
    method: "post",
    data,
  });
}
// C端上传文件
export function uploadDynamicReturnUrl(data) {
  return request({
    url: "/c/file/uploadDynamicReturnUrl",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function companyAdd(data) {
  return request({
    url: "/c/company/add",
    method: "post",
    data,
  });
}

export function agentAdd(data) {
  return request({
    url: "/c/company/agentAdd",
    method: "post",
    data,
  });
}

export function getUserAuditStatus(data) {
  return request({
    url: "/c/company/getUserAuditStatus",
    method: "get",
    params: data,
  });
}

export function getInfo() {
  return request({
    url: "/auth/c/getLoginUser",
    method: "get",
  });
}
// 报表列表
export function getReportList(data) {
  return request({
    url: "/c/report/page",
    method: "get",
    params: data,
  });
}

// 扣费记录
export function getBalancerecord(data) {
  return request({
    url: "/c/balancerecord/page",
    method: "get",
    params: data,
  });
}

export function getAppIdSecret(data) {
  return request({
    url: "/c/user/getAppIdSecret",
    method: "get",
    params: data,
  });
}
//  修改通知地址
// 参数：id
// 参数：notifyUrl  通知地址
export function updateNotifyUr(data) {
  return request({
    url: "/auth/c/updateNotifyUrl",
    method: "post",
    data,
  });
}
// 测试回调 get
export function notifyCallback(data) {
  return request({
    url: "/c/user/notifyCallback",
    method: "get",
    params: data,
  });
}
